import { Observable } from 'rxjs';

import { PresenceDataModeType, SnCamera } from '@lib/api/entities';

import { IFsMap } from '../types';

export abstract class FsMapSwitchableDeviceDataServiceProvider<TMap extends IFsMap, TMarker> {
  public abstract get dock$(): Observable<TMarker>;
  public abstract get dockNearbyCameras$(): Observable<SnCamera>;
  public abstract get hovered$(): Observable<TMarker>;
  public abstract get mouseOut$(): Observable<void>;
  public abstract get advancedMarkers(): TMarker[];

  public abstract selectMarkerByDeviceId$(deviceId: string): Observable<TMarker>;

  public abstract onMapLoaded(map: TMap): void;
  public abstract setupListeners(): void;
  public abstract viewOnMap(marker: TMarker): void;
  public abstract findMarkerAndSelect(marker: TMarker): void;
  public abstract dockStream(marker: TMarker): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
  public abstract getCurrentMode(): PresenceDataModeType;
  public abstract shouldUseShadowMode(): boolean;
  public abstract shouldUseDSA(): boolean;
  public abstract shouldUsePresenceApi(): boolean;
}
